import React from "react";

const LimospayIcon = ({ width, height, color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : 150}
      height={height ? height : 150}
      viewBox="0 0 179 153"
      fill="none"
    >
      <path
        d="M2.76687 98.0851C1.62514 96.6906 1.53352 94.7482 2.63269 93.3199C11.8737 81.3122 56.4031 27.3965 129.071 1.92484C130.67 1.36418 132.459 1.89123 133.505 3.2244L174.241 55.1147C176.06 57.4316 174.899 60.9312 172.083 61.7936C153.815 67.3874 97.8052 88.5842 50.8439 148.921C49.2491 150.97 46.1393 151.059 44.4944 149.05L2.76687 98.0851Z"
        stroke="#00008B"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.2451 90.3742C14.2451 90.3742 53.1029 34.9872 122.088 11.4316L160.284 60.6883C160.284 60.6883 100.239 74.1749 52.8769 138.098L14.2451 90.3742Z"
        fill="#00008B"
      />
    </svg>
  );
};

export default LimospayIcon;
